import { differenceInHours, addDays, setHours, setMinutes } from 'date-fns'

import { Format, Parse } from 'services/Dates'
import { store } from 'store/reducers'

const getStartEnd = (scheduleType, shift = {}) => {
  const { resources, settings } = store.getState()
  const { nonFilterScheduleTypes, scheduleTypesById } = resources
  const { defaultScheduleType } = settings
  const inFormat = 'serverTime'
  const outFormat = 'serverTime'

  // Sets a default value if the provided value is 'multipleValues'
  let parsedStart = shift.start === 'multipleValues' ? new Date() : Parse(shift.start, { inFormat })
  let parsedEnd = shift.end === 'multipleValues' ? new Date() : Parse(shift.end, { inFormat })

  // If the end is before the start, assume an overnight shift type and add a day to the end time.
  if (parsedEnd <= parsedStart) parsedEnd = addDays(parsedEnd, 1)

  // Function to extract a start and end time from a schedule type, using the current start
  const extractStartEndFromScheduleType = scheduleType => {
    // Get the start and end time from the schedule type and set the current form to it.
    const [startHours, startMinutes] = scheduleType.startTime.split(':')
    let selectedStart = setHours(setMinutes(parsedStart, startMinutes), startHours)

    const [endHours, endMinutes] = scheduleType.endTime.split(':')
    let selectedEnd = setHours(setMinutes(parsedStart, endMinutes), endHours)

    return { start: Format(selectedStart, { outFormat }), end: Format(selectedEnd, { outFormat }) }
  }

  if (shift._id === 'new') {
    const shiftLength = differenceInHours(parsedEnd, parsedStart)
    // Handle the case where the person has not dragged a defined shift length, but has just clicked to create a new shift
    if (shiftLength >= 24 || shiftLength < 1)
      return extractStartEndFromScheduleType(scheduleTypesById[defaultScheduleType] || nonFilterScheduleTypes[0] || { startTime: '8:00', endTime: '16:00' })
  }

  // If no schedule type is selected, don't change the start time
  if (scheduleType === 'custom' || typeof scheduleType !== 'object') return {}

  // In last resort, change the start and end to the selected schedule type
  return extractStartEndFromScheduleType(scheduleType)
}

export default getStartEnd
